import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { RolesCollection } from "@tKgpco/Services/SecurityRolesService";
import { SecurityRolesState } from "@tKgpco/Store/Data/SecurityRoles/RolesState";
import { Draft } from "immer";

const initialState: SecurityRolesState = {
    isLoading: false,
    isLoadingOverlay: false,
    roles: null,
    selectedRoleIds: {},
    selectFilter: "",
    selectFilterText: "",
    pagination: null,
    isAllRolesSelected: false,
    rolesDetail: null,
};
type SearchFilterKeys = "selectFilter" | "selectFilterText";
type SearchFilterActionType = {
    key: SearchFilterKeys;
    value: string;
};
export const reducer = {
    "Custom/SecurityRoles/BeginLoad": (draft: Draft<SecurityRolesState>) => {
        draft.isLoading = true;
    },
    "Custom/SecurityRoles/ShowOverlay": (draft: Draft<SecurityRolesState>) => {
        draft.isLoadingOverlay = true;
    },
    "Custom/SecurityRoles/HideOverlay": (draft: Draft<SecurityRolesState>) => {
        draft.isLoadingOverlay = false;
    },
    "Custom/SecurityRoles/CompleteLoad": (draft: Draft<SecurityRolesState>, action: SecurityRolesState) => {
        draft.isLoading = false;
        draft.roles = action.roles;
        draft.pagination = action.roles!.pagination;
    },
    "Custom/SecurityRoles/FailedToLoadRoles": (draft: Draft<SecurityRolesState>) => {
        draft.isLoading = false;
        draft.roles = null;
    },
    "Custom/SecurityRoles/ToggleSelectedRoles": (draft: Draft<SecurityRolesState>, action: { ids: string[] }) => {
        for (const id of action.ids) {
            if (draft.selectedRoleIds[id]) {
                delete draft.selectedRoleIds[id];
            } else {
                draft.selectedRoleIds[id] = true;
            }
        }
    },
    "Custom/SecurityRoles/ClearSelectedRoles": (draft: Draft<SecurityRolesState>) => {
        draft.selectedRoleIds = {};
    },
    "Custom/SecurityRoles/SetSearchFilter": (
        draft: Draft<SecurityRolesState>,
        { filters }: { filters: SearchFilterActionType },
    ) => {
        draft[filters.key] = filters.value;
    },
    "Custom/SecurityRoles/SelectedAllRoles": (
        draft: Draft<SecurityRolesState>,
        action: { isAllRolesSelected: boolean },
    ) => {
        draft.isAllRolesSelected = action.isAllRolesSelected;
    },
    "Custom/EditSecurityRoles/BeginLoad": (draft: Draft<SecurityRolesState>) => {
        draft.isLoading = true;
    },
    "Custom/EditSecurityRoles/CompleteLoad": (draft: Draft<SecurityRolesState>, action: SecurityRolesState) => {
        draft.isLoading = false;
        draft.rolesDetail = action.rolesDetail;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
